import { Col, Row } from '@roo/roo/Grid';
import * as React from 'react';
import { IhistoryCard, getHistoryList, imgUrlMap } from '../api';

const { useState, useEffect, useCallback } = React;

const Index = (props: { orderViewId: string }) => {
    const { orderViewId } = props;
    const [historyList, setHistoryList] = useState<IhistoryCard[]>([]);

    const initHistoryList = useCallback(() => {
        getHistoryList(orderViewId).then(res => {
            setHistoryList(res.data);
        });
    }, [orderViewId]);
    useEffect(() => {
        if (orderViewId !== '') {
            initHistoryList();
        }
    }, [initHistoryList, orderViewId]);

    return (
        <>
            {historyList.map(item => (
                <HistoryCard item={item} />
            ))}
        </>
    );
};

const HistoryCard = (props: { item: IhistoryCard }) => {
    const { item } = props;
    const imgSrc = imgUrlMap[item.operatorRole];
    const currentDate = new Date(parseInt(item.operateTime, 10) * 1000)
        .toLocaleString('zh')
        .replaceAll('/', '-');

    return (
        <div className="historyCard">
            <Row>
                <Col span={2}>
                    <img src={imgSrc} width="40" height="40" />
                </Col>
                <Col span={10}>
                    <Row>{item.title}</Row>
                    <Row>{currentDate}</Row>
                </Col>
            </Row>
            {item.content.map(txt => (
                <p>{txt}</p>
            ))}
        </div>
    );
};

export default Index;
